<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>

    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper" [style.backgroundImage]="getBackgroundImageUrl(allBaniDashboardData.TileImageURL)" [ngClass]="txtColor">
          <div [class.is-mobile]="isHandsetPortrait" class="bani-title">
            <h1 class="bani-name">{{ allBaniDashboardData.BaniName }}</h1>
            <p class="author"><span *ngFor="let author of allBaniDashboardData?.Author;let i = index;">{{ author?.ContributorName }}<span *ngIf="i < allBaniDashboardData?.Author?.length! - 1">, </span></span> </p>
          </div>
        </div>
      </div>

      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- introduction section start -->
        <div class="introduction-wrapper">
          <!-- <div class="carousel-wrapper">
            <owl-carousel-o [options]="customOptions">
              <ng-container *ngFor="let slide of carouselItems">
                <ng-template class="slide" carouselSlide [id]="slide.id">
                  <img [src]="slide.imageUrl" [alt]="slide.altText" [title]="slide.description">
                </ng-template>
              </ng-container>
            </owl-carousel-o>  
          </div> -->
          <mat-grid-list cols="11" rowHeight="360px" gutterSize="20px">
            <mat-grid-tile
              [class.animate]="isBaniIntroductionLoading"
              colspan="{{ isHandsetPortrait ? 11 : 5 }}"
              class="introduction-video-tile"
            >
              <div *ngIf="baniVideoUrls.length == 1"
              (click)="openVideoPopup(allBaniDashboardData.BaniVideoURL, $event)"
                class="video-preview-wrapper carousel-text-wrapper cursor-pointer"
                style="background-image: url('{{ fetchImageThumbnail(allBaniDashboardData) }}'); "
              > 
                <div *ngIf="allBaniDashboardData.BaniVideoURL" class="video-thumbnail-cover">
                  <img alt="play-button" src="/assets/images/play.webp" />
                </div>
              </div>
              <div *ngIf="baniVideoUrls.length > 1"
                class="bani-video-carousel-wrapper">
                <owl-carousel-o [options]="customOptions">
                  <ng-container *ngFor="let video of baniVideoUrls; let i = index;">
                    <ng-template
                      class="slide" carouselSlide id="slide{{i+1}}">
                      <div class="video-preview-wrapper carousel-text-wrapper cursor-pointer"
                          style="background-image: url('{{ fetchBaniVideoThumbnailImage(allBaniDashboardData, video) }}'); "
                          (click)="openVideoPopup(video, $event)"> 
                        <div *ngIf="video" class="video-thumbnail-cover">
                          <img class="btn-play" alt="play-button" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o>  
              </div>
               <div class="igmlpP" *ngIf="baniVideoUrls.length > 1 || baniVideoUrls.length == 1">
                  Available on:
                  <div class="socialLinks">
                  <a href="https://podcasts.apple.com/us/podcast/the-sikh-cast/id1610410001" target="_blank" rel="noopener noreferrer"><div><img src="/assets/images/apple_podcasts.png"  alt="Apple Podcasts Logo" height="28" width="28"></div></a>
                  <a href="https://open.spotify.com/show/1CNFeRMFvlDNERzomNT2p9" target="_blank" rel="noopener noreferrer"><div><img src="/assets/images/spotify.png" alt="Spotify Logo" height="28" width="28"></div></a>
                  <a href="https://sikhcast.podbean.com/" target="_blank" rel="noopener noreferrer"><div><img src="/assets/images/podbean-app.png"  alt="podbean Logo" height="28" width="28"></div></a>
                  </div>
                </div>
            </mat-grid-tile>

            <mat-grid-tile colspan="{{ isHandsetPortrait ? 11 : 6 }}">
              <div class="video-description-wrapper">
                <h2 class="bani-name" *ngIf="allBaniDashboardData.BaniName != undefined">{{ allBaniDashboardData.BaniName }}:</h2> <h2 class="main-heading"> {{ "introduction" | translate }}</h2>
                <div
                  class="main-description"
                  [class.animate]="isBaniDataLoading"
                >
                  <ng-container *ngIf="!isBaniIntroductionLoading">
                    {{ showSmallerIntroductionString(baniIntroduction) }}
                    <span *ngIf="areSeeMoreDotsNeeded"> ... </span>
                  </ng-container>
                </div>
              
                <div
                  class="view-more-buttom-wrapper"
                  [class.is-mobile]="isHandsetPortrait"
                  *ngIf="!isBaniDataLoading"
                >
                  <button
                    class="sggs-primary-button"
                    mat-stroked-button
                    color="primary"
                    (click)="goToIntroductionDetails()"
                  >
                   <a href="{{goToIntroductionDetailsLink()}}" class="view-more-btn">{{ "View More" | translate }}</a> 
                  </button>
                </div>
                 
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
        <!-- introduction section stop -->

        <!-- posts listed on the page start-->
        <!--recent releases start-->
        <div class="featured-wrapper">
          <div class="featured-posts 1" [class.is-mobile]="isHandsetPortrait">
            <mat-grid-list cols="3" [rowHeight]="!allBaniDashboardData.ShowSubSection ? '350px' : '260px'"  gutterSize="5px">
              <ng-container *ngIf="isBaniDataLoading">
                <mat-grid-tile *ngFor="let loading of [0, 1, 2, 3, 4, 5]"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div class="featured-video-thumbnail animate"></div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <div class="loading-heading animate"></div>
                      </div>
                      <div class="featured-video-sub-heading">
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                      </div>
                    </div></div
                ></mat-grid-tile>
              </ng-container>
              <ng-container *ngIf="!isBaniDataLoading && !allBaniDashboardData.ShowSubSection">
                <mat-grid-tile
                  colspan="{{ isHandsetPortrait ? 3 : 1 }}"
                  *ngFor="let baniPart of allBaniDashboardData.Sections"
                  ><div
                    (click)="openBaniSubDetails(baniPart)"
                    class="featured-post-wrapper"
                  >
                    <div class="featured-video-wrapper 2">
                      <div 
                      class="featured-video-thumbnail cust-img-thumb" 
                      
                      [style.backgroundImage]="getBackgroundImageUrlShabd(fetchImageThumbnail(baniPart))"
                      (click)="openVideoPopup(baniPart.BaniVideoURL, $event)"
                      >
                        <div *ngIf="baniPart.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="play-button" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <!-- {{ baniPart.SectionName }} -->
                      </div>
                      <a class="view-more-div" href="{{openBaniSubDetailsLink(baniPart)}}">
                        <div class="featured-video-sub-heading c">
                          {{
                            showSmallerSubSectionSString(
                              baniPart?.SubSection
                            )
                          }}
                          <span class="view-more-link"> {{ "more" | translate }}... </span>
                        </div>
                      </a>
                    </div>
                  </div></mat-grid-tile
                >
              </ng-container>
              <ng-container *ngIf="!isBaniDataLoading && allBaniDashboardData.ShowSubSection">
                <mat-grid-tile
                  colspan="{{ isHandsetPortrait ? 3 : 1 }}"
                  *ngFor="let baniPart of allBaniDashboardData.Sections[0].SubSection"
                  ><div
                    (click)="openBaniSubSectionDetails(baniPart)"
                    class="featured-post-wrapper"
                  >
                    <div class="featured-video-wrapper 2">
                      <div 
                      class="featured-video-thumbnail cust-img-thumb" 
                      
                      [style.backgroundImage]="getBackgroundImageUrlShabd(fetchImageThumbnail(baniPart))"
                      (click)="openVideoPopup(baniPart.BaniVideoURL, $event)"
                      >
                        <div *ngIf="baniPart.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="play-button" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>
                    <div class="featured-video-description" style="text-align: center;">
                      <div class="featured-video-heading">
                        {{ baniPart.SubSectionName }}
                      </div>
                      <!-- <div class="featured-video-sub-heading c"> -->
                        <!-- {{
                          subSectionString(
                            baniPart?.Overview
                          )
                        }} -->
                        <!-- <span class="view-more-link"> {{ "more" | translate }}... </span> -->
                      <!-- </div> -->
                    </div>
                  </div></mat-grid-tile
                >
              </ng-container>
            </mat-grid-list>
          </div>
        </div>
        <!--recent releases stop-->
        <!-- posts listed on the page stop -->

        
      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
